import { mapMutations } from "vuex";

/**
 * @typedef {Object} MenuTree
 * @property {number} ID
 * @property {string} CreatedAt
 * @property {string} UpdatedAt
 * @property {?string} DeletedAt
 * @property {string} color
 */

/**
 * @typedef {Object} Item
 * @property {number} ID
 * @property {string} CreatedAt
 * @property {string} UpdatedAt
 * @property {?string} DeletedAt
 * @property {string} title
 * @property {string} icon
 * @property {string} link
 * @property {string} color
 * @property {string} count
 * @property {number} order
 * @property {number} TotalCount
 * @property {MenuTree} MenuTree
 * @property {number} MenuTreeID
 * @property {boolean} setting
 */

export const base = {
	data() {
		return {
			publicPath: "https://api.reverencehotels.com/",
			filterTag: null,
			/** @type {Item[]} */
			item: null,
			mini: true,
			adminActive: null,
			admin: [],
			menu: [],
			expanseMenus: [],
			drawerExpanseMenus: [],
		};
	},
	methods: {
		pushRoute(link) {
			let push =
				link === "dashboard"
					? { name: "dashboard" }
					: { name: "dashboard-" + link.replace(/\//g, "-") };
			this.$router.push(push);
		},
		...mapMutations({
			drawer: "base/drawer",
		}),
	},
	computed: {
		getLevel() {
			return this.$store.getters["loggedInUser"].level;
		},
		getDrawer: {
			get() {
				return this.$store.getters["base/drawer"];
			},
			set(val) {
				// this.drawer(val)
			},
		},
		getMenu() {
			return this.menu;
		},
		getExpanseMenu() {
			return this.expanseMenus;
		},
		getDrawerExpanseMenus() {
			return this.drawerExpanseMenus;
		},
		getAdmin() {
			return this.admin;
		},
		getSettingsMenuModel: {
			get() {
				if (this.item != null) return null;
				else return this.adminActive;
			},
			set(val) {
				this.item = null;
				this.adminActive = val;
			},
		},
		getMenuModel: {
			get() {
				if (this.adminActive != null) return null;
				else return this.item;
			},
			set(val) {
				this.item = val;
				this.adminActive = null;
			},
		},
		items() {
			return this.$store.getters["privileges"];
		},
	},
};
